import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { 
  collection, addDoc, query, onSnapshot, orderBy, where, getDocs, doc, getDoc, setDoc, updateDoc, deleteDoc, writeBatch, arrayRemove, arrayUnion, increment, serverTimestamp 
} from 'firebase/firestore';

function getLocalContacts() {
  try {
    return JSON.parse(localStorage.getItem('nexora_local_contacts') || '{}');
  } catch (e) {
    return {};
  }
}

const compressImage = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        const maxWidth = 1000;

        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        resolve(canvas.toDataURL('image/jpeg', 0.7));
      };
    };
  });
};

const BroadcastScreen = () => {
  const navigate = useNavigate();
  const mediaInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const historyEndRef = useRef(null);

  const [currentUid, setCurrentUid] = useState(null);
  const [broadcastLists, setBroadcastLists] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  
  
  // পিনড ব্রডকাস্ট লিস্ট
  const [pinnedBroadcastIds, setPinnedBroadcastIds] = useState([]);

  // একাধিক ব্রডকাস্ট লিস্ট সিলেকশন
  const [selectedBroadcastIds, setSelectedBroadcastIds] = useState([]);

  // লং প্রেস একশন বার
  const [selectedBroadcastForAction, setSelectedBroadcastForAction] = useState(null);
  const longPressTimerRef = useRef(null);
  const longPressTriggeredRef = useRef(false);

  // মেম্বার ম্যানেজমেন্ট
  const [activeManagingList, setActiveManagingList] = useState(null);
  const [manageMemberSearch, setManageMemberSearch] = useState('');
  const [showAddMoreModal, setShowAddMoreModal] = useState(false);
  const [selectedNewUidsToAdd, setSelectedNewUidsToAdd] = useState([]);

  // ব্রডকাস্ট হিস্ট্রি দেখা (View Button)
  const [viewingHistoryList, setViewingHistoryList] = useState(null);
  const [broadcastHistoryMsgs, setBroadcastHistoryMsgs] = useState([]);
  const [selectedHistoryMsg, setSelectedHistoryMsg] = useState(null);
  const historyClickRef = useRef({ id: null, count: 0, timer: null });

  // টেক্সট ও ফাইল
  const [messageText, setMessageText] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);

  // নতুন ব্রডকাস্ট মডাল
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [broadcastName, setBroadcastName] = useState('');
  const [searchPrefix, setSearchPrefix] = useState('');
  const [selectedUids, setSelectedUids] = useState([]);
  const [memberPickerSearch, setMemberPickerSearch] = useState('');
  const [memberPickerLoading, setMemberPickerLoading] = useState(false);
  const [memberPickerContacts, setMemberPickerContacts] = useState([]);

  // ভয়েস রেকর্ডার
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const [waveBars, setWaveBars] = useState([12, 22, 35, 18, 30, 10, 28, 40, 15, 18]);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const recordingIntervalRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const animFrameRef = useRef(null);

  // সেভড ফোন কন্টাক্টস
  const [localContacts, setLocalContacts] = useState(getLocalContacts());

  const normalizePhone = (p) => {
    if (!p) return '';
    let d = String(p).replace(/\D/g, '');
    if (!d) return '';
    if (d.startsWith('880')) d = d.substring(3);
    if (d.startsWith('0')) d = d.substring(1);
    return `+880${d}`;
  };

  const loadConnectionMembersForPicker = async (excludeUids = []) => {
    if (!currentUid) return [];
    const myPhone = normalizePhone(currentUid);
    if (!myPhone) return [];

    try {
      setMemberPickerLoading(true);
      const connectionSnap = await getDoc(doc(db, 'connections', myPhone));
      const rawContacts = connectionSnap.exists() ? (connectionSnap.data()?.contacts || {}) : {};
      const userMap = new Map();

      allUsers.forEach((user) => {
        const normalized = normalizePhone(user?.phoneNumber);
        if (normalized && user?.uid) userMap.set(normalized, user);
      });

      const entries = Object.entries(rawContacts)
        .map(([phoneKey, value]) => {
          const phoneFromKey = normalizePhone(phoneKey);
          const candidatePhone = normalizePhone(typeof value === 'object' ? (value?.phoneNumber || phoneKey) : phoneKey);
          const matchedUser = userMap.get(candidatePhone || phoneFromKey);
          if (!matchedUser) return null;

          const savedContactName = localContacts[candidatePhone || phoneFromKey] || (typeof value === 'object' ? value?.name : value) || matchedUser.fullName || candidatePhone || phoneFromKey;

          return {
            uid: matchedUser.uid,
            phoneNumber: matchedUser.phoneNumber,
            displayName: savedContactName,
            photoURL: matchedUser.photoURL || ''
          };
        })
        .filter(Boolean);

      const deduped = new Map();
      entries.forEach((item) => {
        const key = item.uid || item.phoneNumber;
        if (!excludeUids.includes(key) && key !== currentUid && !deduped.has(key)) {
          deduped.set(key, item);
        }
      });

      const ordered = Array.from(deduped.values()).sort((a, b) => (a.displayName || '').localeCompare(b.displayName || '', 'bn', { sensitivity: 'base' }));
      setMemberPickerContacts(ordered);
      return ordered;
    } catch (e) {
      setMemberPickerContacts([]);
      return [];
    } finally {
      setMemberPickerLoading(false);
    }
  };

  const getRoomId = (uid1, uid2) => [uid1, uid2].sort().join('_');

  const handleNavigate = (path, state = {}) => {
    navigate(path, state);
  };

  useEffect(() => {
    const userUid = localStorage.getItem('nexora_user_uid') || auth.currentUser?.uid;

    if (!userUid) {
      navigate('/login');
      return;
    }

    setCurrentUid(userUid);

    const savedPins = JSON.parse(localStorage.getItem(`nexora_b_pins_${userUid}`) || '[]');
    setPinnedBroadcastIds(savedPins);

    const unsubUsers = onSnapshot(collection(db, 'users'), (snapshot) => {
      const uList = [];
      snapshot.forEach(docSnap => {
        const uData = docSnap.data();
        if (uData.uid !== userUid) uList.push(uData);
      });
      setAllUsers(uList);
    });

    const bQuery = query(collection(db, 'broadcasts'), orderBy('createdAt', 'desc'));
    const unsubBroadcasts = onSnapshot(bQuery, (snapshot) => {
      const bList = [];
      snapshot.forEach(docSnap => {
        const bData = docSnap.data();
        if (bData.creatorUid === userUid) {
          bList.push({ id: docSnap.id, ...bData });
        }
      });
      setBroadcastLists(bList);
    });

    return () => {
      unsubUsers();
      unsubBroadcasts();
    };
  }, [navigate]);
  
  // BroadcastScreen.js এর ভেতরে যোগ করুন
useEffect(() => {
  // Broadcast list select করা থাকলে
  // Only multi-select mode hides the persistent bottom navigation.
  if (
    selectedBroadcastIds.length > 0 ||
    selectedBroadcastForAction ||
    activeManagingList ||
    showAddMoreModal
  ) {
    window.dispatchEvent(
      new CustomEvent('nexoraDashboardSelection', {
        detail: { active: true }
      })
    );
  } else {
    window.dispatchEvent(
      new CustomEvent('nexoraDashboardSelection', {
        detail: { active: false }
      })
    );
  }

  // BroadcastScreen ছেড়ে গেলে navigation আবার show হবে
  return () => {
    window.dispatchEvent(
      new CustomEvent('nexoraDashboardSelection', {
        detail: { active: false }
      })
    );
  };
}, [selectedBroadcastIds, selectedBroadcastForAction, activeManagingList, showAddMoreModal]);
  // ব্রডকাস্ট হিস্ট্রি লোড করা
  useEffect(() => {
    if (!viewingHistoryList) return;
    
    const msgsRef = collection(db, 'broadcasts', viewingHistoryList.id, 'messages');
    const q = query(msgsRef, orderBy('createdAt', 'asc'));
    
    const unsub = onSnapshot(q, (snapshot) => {
      const fetched = [];
      snapshot.forEach(d => fetched.push({ id: d.id, ...d.data() }));
      setBroadcastHistoryMsgs(fetched);
      setTimeout(() => historyEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
    });

    return () => unsub();
  }, [viewingHistoryList]);

  const handlePinAction = () => {
    if (!selectedBroadcastForAction) return;
    const id = selectedBroadcastForAction.id;
    let updated = [...pinnedBroadcastIds];
    if (updated.includes(id)) {
      updated = updated.filter(pId => pId !== id);
    } else {
      if (updated.length >= 3) {

        return;
      }
      updated.push(id);
    }
    setPinnedBroadcastIds(updated);
    localStorage.setItem(`nexora_b_pins_${currentUid}`, JSON.stringify(updated));
    setSelectedBroadcastForAction(null);
  };

  const handleDeleteBroadcast = async (broadcastId) => {
    const targetId = broadcastId || selectedBroadcastForAction?.id || activeManagingList?.id;
    if (!targetId) return;

    if (await window.nexoraConfirm("আপনি কি এই ব্রডকাস্ট লিস্টটি ডিলেট করতে চান?")) {
      try {
        await deleteDoc(doc(db, 'broadcasts', targetId));
        setSelectedBroadcastIds(selectedBroadcastIds.filter(id => id !== targetId));
        if (activeManagingList?.id === targetId) setActiveManagingList(null);
        if (selectedBroadcastForAction?.id === targetId) setSelectedBroadcastForAction(null);
      } catch (err) {}
    }
  };

  const handleTouchStartCard = (list) => {
    longPressTriggeredRef.current = false;
    longPressTimerRef.current = setTimeout(() => {
      longPressTriggeredRef.current = true;
      setSelectedBroadcastForAction(list);
    }, 500);
  };

  const handleTouchEndCard = () => {
    if (longPressTimerRef.current) clearTimeout(longPressTimerRef.current);
  };

  // History message: three taps/clicks (or long press) opens the delete action.
  const handleHistoryMessageClick = (msg) => {
    const now = Date.now();
    const current = historyClickRef.current;

    if (current.id !== msg.id || now - (current.lastAt || 0) > 700) {
      if (current.timer) clearTimeout(current.timer);
      historyClickRef.current = { id: msg.id, count: 1, lastAt: now, timer: null };
      return;
    }

    const nextCount = current.count + 1;
    current.count = nextCount;
    current.lastAt = now;

    if (nextCount >= 3) {
      setSelectedHistoryMsg(msg);
      current.count = 0;
      if (current.timer) clearTimeout(current.timer);
      current.timer = null;
    } else {
      if (current.timer) clearTimeout(current.timer);
      current.timer = setTimeout(() => {
        historyClickRef.current = { id: null, count: 0, timer: null };
      }, 750);
    }
  };

  const handleHistoryMessageLongPress = (msg) => {
    setSelectedHistoryMsg(msg);
  };

  const handleDeleteBroadcastHistoryMessage = async (msg) => {
    if (!msg || !viewingHistoryList || !currentUid) return;

    const recipientUids = Array.from(new Set(
      (Array.isArray(msg.recipientUids) && msg.recipientUids.length > 0
        ? msg.recipientUids
        : (viewingHistoryList.memberUids || [])
      ).filter(Boolean)
    ));

    if (!msg.broadcastMessageId) {
      window.nexoraAlert('এই পুরোনো broadcast message-এ global delete ID নেই। নতুন করে পাঠানো message-এ এই অপশন কাজ করবে।');
      setSelectedHistoryMsg(null);
      return;
    }

    const ok = await window.nexoraConfirm('এই broadcast message-টি সব recipient-এর chat থেকেও delete করবেন?');
    if (!ok) return;

    try {
      // Each recipient received a normal 1-to-1 chat message. The shared
      // broadcastMessageId lets us remove exactly this broadcast copy.
      for (const recipientUid of recipientUids) {
        const roomId = getRoomId(currentUid, recipientUid);
        const q = query(
          collection(db, 'chats', roomId, 'messages'),
          where('broadcastMessageId', '==', msg.broadcastMessageId)
        );
        const snap = await getDocs(q);

        if (snap.empty) continue;

        let batch = writeBatch(db);
        let batchCount = 0;
        for (const messageDoc of snap.docs) {
          batch.delete(messageDoc.ref);
          batchCount++;
          if (batchCount >= 450) {
            await batch.commit();
            batch = writeBatch(db);
            batchCount = 0;
          }
        }
        if (batchCount > 0) await batch.commit();
      }

      // Remove it from the sender's broadcast history as well.
      await deleteDoc(doc(db, 'broadcasts', viewingHistoryList.id, 'messages', msg.id));

      setBroadcastHistoryMsgs(prev => prev.filter(item => item.id !== msg.id));
      setSelectedHistoryMsg(null);
    } catch (err) {
      console.error('Broadcast global delete failed:', err);
      window.nexoraAlert('Message delete করা যায়নি। আবার চেষ্টা করুন।');
    }
  };

  const phonebookKeys = Object.keys(localContacts);

  const phonebookSavedUsers = allUsers.filter(u => {
    const normP = normalizePhone(u.phoneNumber);
    return phonebookKeys.includes(normP);
  }).map(u => {
    const normP = normalizePhone(u.phoneNumber);
    return {
      uid: u.uid,
      phone: normP,
      displayName: localContacts[normP] || u.fullName || normP,
      photoURL: u.photoURL
    };
  });

  const filteredContacts = memberPickerContacts.filter((c) => {
    const qLower = searchPrefix.toLowerCase().trim();
    if (!qLower) return true;
    return (c.displayName || '').toLowerCase().includes(qLower) || (c.phoneNumber || '').toLowerCase().includes(qLower);
  });

  useEffect(() => {
    if (!currentUid || !showCreateModal) return;
    const exclude = Array.from(new Set(selectedUids.filter(Boolean)));
    loadConnectionMembersForPicker(exclude);
  }, [currentUid, showCreateModal, allUsers, selectedUids.join(',')]);

  useEffect(() => {
    if (!showAddMoreModal || !activeManagingList || !currentUid) return;
    const exclude = Array.from(new Set((activeManagingList.memberUids || []).filter(Boolean) || []));
    loadConnectionMembersForPicker(exclude);
    setMemberPickerSearch('');
  }, [showAddMoreModal, activeManagingList?.id, currentUid]);

  const handleSelectAllFiltered = () => {
    const filteredUids = filteredContacts.map(c => c.uid);
    const merged = Array.from(new Set([...selectedUids, ...filteredUids]));
    setSelectedUids(merged);
  };

  const toggleSelectUser = (uid) => {
    if (selectedUids.includes(uid)) {
      setSelectedUids(selectedUids.filter(id => id !== uid));
    } else {
      setSelectedUids([...selectedUids, uid]);
    }
  };

  const toggleSelectBroadcastList = (list) => {
    if (longPressTriggeredRef.current) {
      longPressTriggeredRef.current = false;
      return;
    }
    if (selectedBroadcastForAction) {
      setSelectedBroadcastForAction(null);
      return;
    }
    const listId = list.id;
    if (selectedBroadcastIds.includes(listId)) {
      setSelectedBroadcastIds(selectedBroadcastIds.filter(id => id !== listId));
    } else {
      setSelectedBroadcastIds([...selectedBroadcastIds, listId]);
    }
  };

  const handleCreateBroadcastList = async () => {
    if (!broadcastName.trim() || selectedUids.length === 0 || !currentUid) {

      return;
    }

    try {
      await addDoc(collection(db, 'broadcasts'), {
        name: broadcastName.trim(),
        creatorUid: currentUid,
        memberUids: selectedUids,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        lastMessage: 'Broadcast list created'
      });

      setShowCreateModal(false);
      setBroadcastName('');
      setSelectedUids([]);
      setSearchPrefix('');
    
    } catch (e) {
    
    }
  };

  const handleAddMoreMembersToExisting = async () => {
    if (!activeManagingList || selectedNewUidsToAdd.length === 0) return;

    try {
      await updateDoc(doc(db, 'broadcasts', activeManagingList.id), {
        memberUids: arrayUnion(...selectedNewUidsToAdd)
      });

     
      setSelectedNewUidsToAdd([]);
      setShowAddMoreModal(false);
    } catch (e) {}
  };

  const handleRemoveMemberFromBroadcast = async (broadcastId, memberUid) => {
    if (await window.nexoraConfirm("মেম্বারকে ব্রডকাস্ট থেকে রিমুভ করতে চান?")) {
      try {
        await updateDoc(doc(db, 'broadcasts', broadcastId), {
          memberUids: arrayRemove(memberUid)
        });
      } catch (e) {}
    }
  };

  const startMicPreviewStream = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
const analyser = audioCtx.createAnalyser();
const source = audioCtx.createMediaStreamSource(stream);

analyser.fftSize = 64;
analyser.smoothingTimeConstant = 0.55;
source.connect(analyser);

audioContextRef.current = audioCtx;
analyserRef.current = analyser;

const dataArray = new Uint8Array(analyser.frequencyBinCount);

const updateWave = () => {
  analyser.getByteFrequencyData(dataArray);

  const bars = Array.from(dataArray.slice(0, 10)).map((v) => {
    const noiseFloor = 2;

    if (v <= noiseFloor) {
      return 6;
    }

    let normalized = (v - noiseFloor) / (255 - noiseFloor);

    normalized = Math.min(
      1,
      Math.pow(normalized, 0.55) * 1.7
    );

    return Math.round(6 + normalized * 30);
  });

  setWaveBars(bars);
  animFrameRef.current = requestAnimationFrame(updateWave);
};

updateWave();
return stream;

      updateWave();
      return stream;
    } catch (e) {
      return null;
    }
  };

  const stopMicPreviewStream = () => {
    if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
    if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
      audioContextRef.current.close().catch(() => {});
    }
  };

  const openVoiceModal = async () => {
    if (selectedBroadcastIds.length === 0) {

      return;
    }
    setShowVoiceModal(true);
    setIsRecording(false);
    setRecordingTime(0);
    await startMicPreviewStream();
  };

  const handleCircleVoiceClick = async () => {
    if (isRecording) {
      stopAndSendVoice();
    } else {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        mediaRecorderRef.current = new MediaRecorder(stream);
        audioChunksRef.current = [];

        mediaRecorderRef.current.ondataavailable = (e) => {
          if (e.data.size > 0) audioChunksRef.current.push(e.data);
        };

        mediaRecorderRef.current.onstop = () => {
          stopMicPreviewStream();
          const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
          const reader = new FileReader();
          reader.readAsDataURL(audioBlob);
          reader.onloadend = () => {
            dispatchPayloadToRecipients('voice', { 
              audioData: reader.result, 
              duration: `${recordingTime}s` 
            }, '🎙️ Voice message');
          };
          stream.getTracks().forEach((t) => t.stop());
        };

        mediaRecorderRef.current.start();
        setIsRecording(true);
        setRecordingTime(0);

        recordingIntervalRef.current = setInterval(() => {
          setRecordingTime((prev) => prev + 1);
        }, 1000);

      } catch (err) {
  
      }
    }
  };

  const stopAndSendVoice = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      clearInterval(recordingIntervalRef.current);
      setShowVoiceModal(false);
    }
  };

  const cancelVoiceModal = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.onstop = null;
      mediaRecorderRef.current.stop();
    }
    stopMicPreviewStream();
    clearInterval(recordingIntervalRef.current);
    setIsRecording(false);
    setShowVoiceModal(false);
  };

  // ব্রডকাস্ট মেসেজ পাঠানো এবং আনরিড কাউন্ট ফিক্স করা
  const dispatchPayloadToRecipients = async (type, payloadExtra, summaryText) => {
    if (selectedBroadcastIds.length === 0 || !currentUid) return;

    let targetRecipientUids = [];
    broadcastLists.forEach(bList => {
      if (selectedBroadcastIds.includes(bList.id) && bList.memberUids) {
        targetRecipientUids.push(...bList.memberUids);
      }
    });

    const uniqueRecipients = Array.from(new Set(targetRecipientUids));
    if (uniqueRecipients.length === 0) return;

    try {
      // One shared ID is attached to every 1-to-1 copy and the broadcast history
      // entry. This makes a future global delete precise and safe.
      const broadcastMessageId = `bmsg_${currentUid}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      const sentTimeStr = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

      // ১. প্রত্যেক ইউজারকে পার্সোনাল মেসেজ দেওয়া (আনরিড কাউন্ট আপডেট সহ)
      for (let targetUid of uniqueRecipients) {
        const roomId = getRoomId(currentUid, targetUid);
        const roomRef = doc(db, 'chats', roomId);

        const msgData = {
          senderId: currentUid,
          type,
          status: 'sent',
          broadcastMessageId,
          broadcastListId: null,
          createdAt: serverTimestamp(),
          timeStr: sentTimeStr,
          ...payloadExtra
        };

        await addDoc(collection(db, 'chats', roomId, 'messages'), msgData);

        // আনরিড কাউন্ট যেন নিখুঁতভাবে কাজ করে তার লজিক
        try {
          await updateDoc(roomRef, {
            roomId,
            participants: [currentUid, targetUid],
            lastMessage: summaryText,
            lastSenderId: currentUid,
            updatedAt: serverTimestamp(),
            [`unreadCount.${targetUid}`]: increment(1),
            [`unreadCount.${currentUid}`]: 0
          });
        } catch (err) {
          // যদি চ্যাট রুম আগে থেকে না থাকে
          await setDoc(roomRef, {
            roomId,
            participants: [currentUid, targetUid],
            lastMessage: summaryText,
            lastSenderId: currentUid,
            updatedAt: serverTimestamp(),
            unreadCount: {
              [targetUid]: 1,
              [currentUid]: 0
            }
          });
        }
      }

      // ২. ব্রডকাস্ট হিস্ট্রিতে মেসেজটি সেভ করে রাখা
      for (let bId of selectedBroadcastIds) {
        await updateDoc(doc(db, 'broadcasts', bId), {
          lastMessage: summaryText,
          updatedAt: serverTimestamp()
        });

        // Save the exact recipient snapshot with the history message. This is
        // important if a recipient is removed from the broadcast list later: a
        // global delete must still remove the old copy from that user's chat.
        await addDoc(collection(db, 'broadcasts', bId, 'messages'), {
          senderId: currentUid,
          type,
          status: 'sent',
          broadcastMessageId,
          recipientUids: uniqueRecipients,
          createdAt: serverTimestamp(),
          timeStr: sentTimeStr,
          ...payloadExtra
        });
      }

   
    } catch (err) {
 
    } finally {
      setUploadProgress(0);
    }
  };

  const handleSendText = (e) => {
    e.preventDefault();
    if (!messageText.trim()) return;
    const msgText = messageText.trim();
    setMessageText('');
    dispatchPayloadToRecipients('text', { text: msgText }, msgText);
  };

  const handleMediaSelect = async (e) => {
    const file = e.target.files[0];
    if (!file || selectedBroadcastIds.length === 0) return;

    setUploadProgress(30);

    if (file.type.startsWith('video/')) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        setUploadProgress(85);
        await dispatchPayloadToRecipients('video', { mediaData: reader.result }, '🎥 Video');
      };
    } else {
      const base64Img = await compressImage(file);
      setUploadProgress(85);
      await dispatchPayloadToRecipients('image', { mediaData: base64Img }, '📷 Photo');
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file || selectedBroadcastIds.length === 0) return;

    setUploadProgress(30);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      setUploadProgress(85);
      await dispatchPayloadToRecipients('file', {
        fileData: reader.result,
        fileName: file.name,
        fileSize: (file.size / (1024 * 1024)).toFixed(1) + ' MB'
      }, `📄 ${file.name}`);
    };
  };

  const processedBroadcasts = broadcastLists.map(list => ({
    ...list,
    sortTime: list.updatedAt?.seconds ? list.updatedAt.seconds * 1000 : (list.createdAt?.seconds ? list.createdAt.seconds * 1000 : Date.now())
  }));

  const pinnedB = processedBroadcasts.filter(b => pinnedBroadcastIds.includes(b.id));
  const unpinnedB = processedBroadcasts.filter(b => !pinnedBroadcastIds.includes(b.id));

  unpinnedB.sort((a, b) => b.sortTime - a.sortTime);

  const finalBroadcastList = [...pinnedB, ...unpinnedB];

  return (
    <div style={styles.container}>
      <style>{`
        * { box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }

        html, body, #root {
          margin: 0; padding: 0;
          height: 100dvh; width: 100vw;
          overflow: hidden; position: fixed;
          background: #fafafa;
        }

        .broadcast-shell {
          width: 100%;
          max-width: 480px;
          height: 100dvh;
          max-height: 100dvh;
          background: #fafafa;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
          box-shadow: 0 0 40px rgba(0,0,0,0.04);
        }

        @media (min-width: 768px) {
          .broadcast-shell { height: 92vh; border-radius: 36px; border: 1px solid #f1f5f9; }
        }

        /* হেডার পজিশনিং (ফিক্সড) */
        .header-bar {
          flex: none; width: 100%;
          padding: 12px 20px; padding-top: max(16px, env(safe-area-inset-top));
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #f1f5f9;
          z-index: 30;
        }

        .selection-top-bar {
          flex: none; width: 100%;
          padding: 14px 20px; padding-top: max(16px, env(safe-area-inset-top));
          background: #1e293b;
          color: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          z-index: 50;
        }

        /* মাঝখানের স্ক্রল এরিয়া (flex: 1 1 auto এবং min-height: 0) */
        .scrollable-content {
          flex: 1 1 auto;
          min-height: 0;
          overflow-y: auto;
          padding: 16px;
          display: flex;
          flex-direction: column;
          gap: 12px;
          -webkit-overflow-scrolling: touch;
        }

        .broadcast-card-item {
          background: #ffffff;
          border-radius: 20px;
          padding: 14px 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          border: 1px solid #f1f5f9;
          box-shadow: 0 4px 12px rgba(0,0,0,0.02);
          user-select: none;
          transition: all 0.15s ease;
        }
        .broadcast-card-item.selected-card {
          border: 2px solid #62b875;
          background: #f0fdf4;
        }

        .broadcast-shell input[type="text"],
        .broadcast-shell input[type="url"],
        .broadcast-shell input[type="tel"],
        .broadcast-shell textarea {
          user-select: text;
          -webkit-user-select: text;
          -webkit-touch-callout: default;
        }

        .create-btn-pill {
          background: #62b875;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 20px;
          font-weight: 800;
          font-size: 13px;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(98, 184, 117, 0.3);
        }

        /* ফুটার পজিশনিং (ফিক্সড) */
        .chat-input-form {
          flex: none; width: 100%;
          padding: 10px 12px; padding-bottom: max(12px, env(safe-area-inset-bottom));
          background: #ffffff;
          display: flex;
          align-items: center;
          gap: 8px;
          z-index: 30;
          border-top: 1px solid #f1f5f9;
        }

        .black-action-btn { 
          width: 48px; 
          height: 48px; 
          border-radius: 50%; 
          background: rgba(24, 24, 27, 0.7); 
          backdrop-filter: blur(8px);
          color: white; 
          border: none; 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          cursor: pointer; 
          flex-shrink: 0;
          padding: 0; margin: 0;
        }

        .bottom-sheet-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.4); backdrop-filter: blur(4px); z-index: 300; display: flex; align-items: flex-end; justify-content: center; }
        
        .voice-card-bottom { width: 100%; max-width: 480px; background: #ffffff; border-radius: 28px 28px 0 0; padding: 20px 24px 28px; box-shadow: 0 -10px 30px rgba(0,0,0,0.12); position: relative; text-align: center; border-top: 1px solid #f1f5f9; animation: slideUp 0.25s ease-out; }
        @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }

        .voice-circle { width: 96px; height: 96px; border-radius: 50%; background: #f0fdf4; border: 3px solid #62b875; display: flex; align-items: center; justify-content: center; margin: 12px auto 0; cursor: pointer; transition: all 0.2s; box-shadow: 0 8px 20px rgba(98, 184, 117, 0.2); }
        .voice-circle.recording { background: #fef2f2; border-color: #ef4444; box-shadow: 0 8px 20px rgba(239, 68, 68, 0.3); animation: pulseRed 1.5s infinite; }
        @keyframes pulseRed { 0% { transform: scale(0.96); } 50% { transform: scale(1.04); } 100% { transform: scale(0.96); } }

        .full-modal-sheet {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: #ffffff;
          z-index: 200;
          display: flex;
          flex-direction: column;
          animation: slideUp 0.25s ease-out;
        }
      `}</style>

      {/* মিডিয়া ও ফাইল ইনপুটস */}
      <input type="file" ref={mediaInputRef} accept="image/*,video/*" onChange={handleMediaSelect} style={{ display: 'none' }} />
      <input type="file" ref={fileInputRef} accept="*" onChange={handleFileSelect} style={{ display: 'none' }} />

      {/* ব্রডকাস্ট হিস্ট্রি দেখার মডাল */}
      {viewingHistoryList && (
        <div className="full-modal-sheet" style={{ zIndex: 250 }}>
          <div className="header-bar">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button onClick={() => setViewingHistoryList(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800' }}>{viewingHistoryList.name} (History)</h3>
                <span style={{ fontSize: '11px', color: '#64748b' }}>{viewingHistoryList.memberUids?.length || 0} recipients</span>
              </div>
            </div>
          </div>

          <div className="scrollable-content" style={{ background: '#f8fafc' }}>
            {broadcastHistoryMsgs.length === 0 ? (
              <div style={{ textAlign: 'center', color: '#94a3b8', marginTop: '40px', fontSize: '13px' }}>
                No messages broadcasted yet.
              </div>
            ) : (
              broadcastHistoryMsgs.map(msg => (
                <div
                  key={msg.id}
                  style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', alignItems: 'flex-end', width: '100%' }}
                  onContextMenu={(e) => { e.preventDefault(); handleHistoryMessageLongPress(msg); }}
                  onTouchStart={() => {
                    const timer = setTimeout(() => handleHistoryMessageLongPress(msg), 550);
                    msg.__historyLongPressTimer = timer;
                  }}
                  onTouchEnd={() => {
                    if (msg.__historyLongPressTimer) clearTimeout(msg.__historyLongPressTimer);
                  }}
                  onTouchCancel={() => {
                    if (msg.__historyLongPressTimer) clearTimeout(msg.__historyLongPressTimer);
                  }}
                  onClick={() => handleHistoryMessageClick(msg)}
                >
                  <div style={{ background: '#62b875', color: '#ffffff', borderRadius: '18px 18px 2px 18px', padding: '10px 14px', maxWidth: '80%', fontSize: '14px', cursor: 'pointer' }}>
                    {msg.type === 'text' && <div>{msg.text}</div>}
                    {msg.type === 'image' && <img src={msg.mediaData} style={{ width: '100%', borderRadius: '12px' }} alt="Sent" />}
                    {msg.type === 'video' && <video src={msg.mediaData} controls style={{ width: '100%', borderRadius: '12px' }} />}
                    {msg.type === 'file' && <div style={{ fontWeight: 'bold' }}>📄 {msg.fileName}</div>}
                    {msg.type === 'voice' && <audio src={msg.audioData} controls style={{ height: '30px' }} />}
                    <div style={{ fontSize: '10px', opacity: 0.8, textAlign: 'right', marginTop: '4px' }}>{msg.timeStr}</div>
                  </div>

                  {selectedHistoryMsg?.id === msg.id && (
                    <div style={{ display: 'flex', gap: '8px', marginTop: '6px', marginRight: '4px', padding: '6px', background: '#ffffff', borderRadius: '12px', boxShadow: '0 6px 20px rgba(0,0,0,0.12)', border: '1px solid #e2e8f0' }}>
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleDeleteBroadcastHistoryMessage(msg); }}
                        style={{ border: 'none', background: '#fee2e2', color: '#dc2626', borderRadius: '9px', padding: '8px 12px', fontSize: '12px', fontWeight: '800', cursor: 'pointer' }}
                      >
                        🗑 Delete for everyone
                      </button>
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); setSelectedHistoryMsg(null); }}
                        style={{ border: 'none', background: '#f1f5f9', color: '#475569', borderRadius: '9px', padding: '8px 12px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              ))
            )}
            <div ref={historyEndRef} />
          </div>
        </div>
      )}

      {/* ভয়েস রেকর্ডার বটম শিট */}
      {showVoiceModal && (
        <div className="bottom-sheet-overlay">
          <div className="voice-card-bottom">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '14px', fontWeight: '800', color: '#0f172a' }}>Voice Note to Broadcast</span>
              <button onClick={cancelVoiceModal} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#64748b', padding: '0 4px' }}>✕</button>
            </div>

            <div className={`voice-circle ${isRecording ? 'recording' : ''}`} onClick={handleCircleVoiceClick}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', height: '36px' }}>
                {waveBars.map((val, idx) => (
                  <div key={idx} style={{ width: '4px', height: `${val}px`, backgroundColor: isRecording ? '#ef4444' : '#62b875', borderRadius: '4px', transition: 'height 0.05s ease' }} />
                ))}
              </div>
            </div>

            <div style={{ marginTop: '12px' }}>
              <div style={{ fontSize: '15px', fontWeight: '800', color: isRecording ? '#ef4444' : '#0f172a' }}>
                {isRecording ? `Recording... (${recordingTime}s)` : 'Tap on start record'}
              </div>
            </div>

            <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
              <button onClick={cancelVoiceModal} style={{ flex: 1, padding: '10px', background: '#f1f5f9', border: 'none', borderRadius: '12px', fontWeight: '700', color: '#64748b', cursor: 'pointer', fontSize: '12px' }}>Cancel</button>
              <button onClick={() => { cancelVoiceModal(); setTimeout(openVoiceModal, 200); }} style={{ flex: 1, padding: '10px', background: '#e2f4e6', border: 'none', borderRadius: '12px', fontWeight: '700', color: '#15803d', cursor: 'pointer', fontSize: '12px' }}>Re-record</button>
            </div>
          </div>
        </div>
      )}

      {/* নতুন মেম্বার অ্যাড করার মডাল */}
      {showAddMoreModal && activeManagingList && (
        <div className="full-modal-sheet" style={{ zIndex: 220 }}>
          <div className="header-bar">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button onClick={() => { setShowAddMoreModal(false); setSelectedNewUidsToAdd([]); setMemberPickerSearch(''); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800' }}>Add Members</h3>
            </div>
            <span style={{ fontSize: '12px', fontWeight: '800', color: '#62b875' }}>{selectedNewUidsToAdd.length} selected</span>
          </div>

          <div className="scrollable-content">
            <input
              type="text"
              value={memberPickerSearch}
              onChange={(e) => setMemberPickerSearch(e.target.value)}
              placeholder="Search contacts by name or phone..."
              style={{ width: '100%', padding: '12px 14px', border: '1px solid #e2e8f0', borderRadius: '14px', outline: 'none', fontSize: '14px', marginBottom: '14px', fontWeight: '600' }}
            />

            <div style={{ fontSize: '12px', fontWeight: '800', color: '#64748b', marginBottom: '8px' }}>
              Contacts on Nexora
            </div>

            {memberPickerLoading ? (
              <div style={{ padding: '18px 0', textAlign: 'center', color: '#64748b', fontSize: '13px' }}>Loading contacts...</div>
            ) : (() => {
              const availableToAdd = memberPickerContacts.filter(c => !activeManagingList.memberUids?.includes(c.uid));
              const filteredMembers = availableToAdd.filter(c => {
                const q = memberPickerSearch.trim().toLowerCase();
                if (!q) return true;
                return (c.displayName || '').toLowerCase().includes(q) || (c.phoneNumber || '').toLowerCase().includes(q);
              });

              if (filteredMembers.length === 0) {
                return <div style={{ padding: '18px 0', textAlign: 'center', color: '#64748b', fontSize: '13px' }}>{memberPickerSearch ? 'No contacts found' : 'No contacts available'}</div>;
              }

              return filteredMembers.map(c => {
                const isSelected = selectedNewUidsToAdd.includes(c.uid);

                return (
                  <div 
                    key={c.uid}
                    onClick={() => {
                      if (selectedNewUidsToAdd.includes(c.uid)) {
                        setSelectedNewUidsToAdd(selectedNewUidsToAdd.filter(id => id !== c.uid));
                      } else {
                        setSelectedNewUidsToAdd([...selectedNewUidsToAdd, c.uid]);
                      }
                    }}
                    style={{ padding: '10px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #f8fafc', cursor: 'pointer' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <img src={c.photoURL || "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150"} alt="User" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                      <div>
                        <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '700' }}>{c.displayName}</h4>
                        <span style={{ fontSize: '11px', color: '#64748b' }}>{c.phoneNumber}</span>
                      </div>
                    </div>
                    <input type="checkbox" checked={isSelected} readOnly style={{ width: '18px', height: '18px' }} />
                  </div>
                );
              });
            })()}
          </div>

          <div style={{ padding: '16px 20px', borderTop: '1px solid #f1f5f9' }}>
            <button 
              onClick={handleAddMoreMembersToExisting}
              disabled={selectedNewUidsToAdd.length === 0}
              style={{ width: '100%', padding: '14px', background: selectedNewUidsToAdd.length > 0 ? '#62b875' : '#dbeafe', color: selectedNewUidsToAdd.length > 0 ? 'white' : '#64748b', border: 'none', borderRadius: '16px', fontWeight: '800', fontSize: '15px', cursor: selectedNewUidsToAdd.length > 0 ? 'pointer' : 'not-allowed' }}
            >
              Add Selected ({selectedNewUidsToAdd.length})
            </button>
          </div>
        </div>
      )}

      {/* মেম্বারস ম্যানেজমেন্ট মডাল */}
      {activeManagingList && (
        <div className="full-modal-sheet">
          <div className="header-bar">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button onClick={() => setActiveManagingList(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#0f172a' }}>{activeManagingList.name}</h3>
            </div>
            <button onClick={() => handleDeleteBroadcast(activeManagingList.id)} style={{ padding: '6px 12px', background: '#fef2f2', color: '#ef4444', border: 'none', borderRadius: '12px', fontWeight: '800', fontSize: '12px', cursor: 'pointer' }}>
              Delete 🗑️
            </button>
          </div>

          <div className="scrollable-content">
            <button 
              onClick={() => setShowAddMoreModal(true)}
              style={{ width: '100%', padding: '12px', background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#16a34a', borderRadius: '14px', fontWeight: '800', fontSize: '13px', cursor: 'pointer', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
            >
              <span>👤+</span> <span>Add More Members from Contacts</span>
            </button>

            <input 
              type="text" 
              placeholder="Search Members..." 
              value={manageMemberSearch}
              onChange={e => setManageMemberSearch(e.target.value)}
              style={{ width: '100%', padding: '12px', border: '1px solid #e2e8f0', borderRadius: '14px', outline: 'none', fontSize: '14px', marginBottom: '14px' }}
            />

            <div style={{ fontSize: '13px', fontWeight: '800', color: '#64748b', marginBottom: '8px' }}>
              Members ({activeManagingList.memberUids?.length || 0}):
            </div>

            {activeManagingList.memberUids?.map(mUid => {
              const uData = allUsers.find(u => u.uid === mUid);
              if (!uData) return null;
              const uNorm = normalizePhone(uData.phoneNumber);
              const sName = localContacts[uNorm] || uData.fullName || uNorm;

              if (manageMemberSearch && !sName.toLowerCase().includes(manageMemberSearch.toLowerCase())) return null;

              return (
                <div key={mUid} style={{ padding: '10px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #f8fafc' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <img src={uData.photoURL || "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150"} alt="User" style={{ width: '38px', height: '38px', borderRadius: '50%' }} />
                    <div>
                      <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '700' }}>{sName}</h4>
                      <span style={{ fontSize: '11px', color: '#64748b' }}>{uData.phoneNumber}</span>
                    </div>
                  </div>

                  <button 
                    onClick={() => handleRemoveMemberFromBroadcast(activeManagingList.id, mUid)}
                    style={{ padding: '4px 10px', background: '#fef2f2', color: '#ef4444', border: 'none', borderRadius: '8px', fontWeight: '700', fontSize: '11px', cursor: 'pointer' }}
                  >
                    Remove
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* নতুন ব্রডকাস্ট মডাল */}
      {showCreateModal && (
        <div className="full-modal-sheet">
          <div className="header-bar">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button onClick={() => setShowCreateModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#0f172a' }}>New Broadcast List</h3>
            </div>
            <span style={{ fontSize: '12px', fontWeight: '800', color: '#62b875' }}>{selectedUids.length} selected</span>
          </div>

          <div className="scrollable-content">
            <input 
              type="text" 
              placeholder="Broadcast List Name (e.g. Batch a1)" 
              value={broadcastName}
              onChange={e => setBroadcastName(e.target.value)}
              style={{ width: '100%', padding: '14px', border: '2px solid #62b875', borderRadius: '16px', fontWeight: '800', outline: 'none', marginBottom: '16px', fontSize: '15px' }}
            />

            <div style={{ display: 'flex', gap: '8px', marginBottom: '14px' }}>
              <input 
                type="text" 
                placeholder="Search prefix (e.g. a1, 11, aa)..." 
                value={searchPrefix}
                onChange={e => setSearchPrefix(e.target.value)}
                style={{ flex: 1, padding: '12px', border: '1px solid #e2e8f0', borderRadius: '14px', outline: 'none', fontSize: '14px', fontWeight: '600' }}
              />

              <button 
                onClick={handleSelectAllFiltered}
                style={{ padding: '0 16px', background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#16a34a', borderRadius: '14px', fontWeight: '800', fontSize: '12px', cursor: 'pointer', whiteSpace: 'nowrap' }}
              >
                Select All ({filteredContacts.length})
              </button>
            </div>

            <div style={{ fontSize: '12px', fontWeight: '800', color: '#64748b', marginBottom: '8px' }}>
              Select Saved Contacts on Nexora:
            </div>

            {filteredContacts.map(c => {
              const isSelected = selectedUids.includes(c.uid);

              return (
                <div 
                  key={c.uid}
                  onClick={() => toggleSelectUser(c.uid)}
                  style={{ padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #f8fafc', cursor: 'pointer', background: isSelected ? '#f0fdf4' : 'transparent', borderRadius: '12px' }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <img src={c.photoURL || "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150"} alt="User" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                    <div>
                      <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: '#0f172a' }}>{c.displayName}</h4>
                      <span style={{ fontSize: '11px', color: '#64748b' }}>{c.phone}</span>
                    </div>
                  </div>
                  <input type="checkbox" checked={isSelected} readOnly style={{ width: '18px', height: '18px' }} />
                </div>
              );
            })}
          </div>

          <div style={{ padding: '16px 20px', borderTop: '1px solid #f1f5f9' }}>
            <button 
              onClick={handleCreateBroadcastList}
              style={{ width: '100%', padding: '14px', background: '#62b875', color: 'white', border: 'none', borderRadius: '16px', fontWeight: '800', fontSize: '15px', cursor: 'pointer', boxShadow: '0 4px 12px rgba(98, 184, 117, 0.3)' }}
            >
              Create Broadcast List ({selectedUids.length})
            </button>
          </div>
        </div>
      )}

      {/* মেইন ব্রডকাস্ট স্ক্রিন */}
      <div className="broadcast-shell">
        
        {/* ১. লং প্রেস করলে WhatsApp Style একশন হেডার বার */}
        {selectedBroadcastForAction ? (
          <div className="selection-top-bar">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button onClick={() => setSelectedBroadcastForAction(null)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '18px', cursor: 'pointer', padding: 0 }}>✕</button>
              <span style={{ fontWeight: '800', fontSize: '15px' }}>{selectedBroadcastForAction.name}</span>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <button onClick={handlePinAction} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: 'white' }} title="Pin / Unpin">📌</button>
              <button onClick={() => { setActiveManagingList(selectedBroadcastForAction); setSelectedBroadcastForAction(null); }} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: 'white' }} title="Manage Members">⚙️</button>
              <button onClick={() => handleDeleteBroadcast(selectedBroadcastForAction.id)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#ef4444' }} title="Delete List">🗑️</button>
            </div>
          </div>
        ) : (
          <div className="header-bar">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <div>
                <h2 style={{ fontSize: '18px', fontWeight: '800', margin: 0, color: '#0f172a' }}>Broadcast Lists</h2>
                <span style={{ fontSize: '11px', color: '#62b875', fontWeight: '700' }}>
                  {selectedBroadcastIds.length > 0 ? `${selectedBroadcastIds.length} lists selected` : `${broadcastLists.length} lists active`}
                </span>
              </div>
            </div>

            <button onClick={() => setShowCreateModal(true)} className="create-btn-pill">
              + Create List
            </button>
          </div>
        )}

        {uploadProgress > 0 && (
          <div style={{ padding: '8px 16px', background: '#f0fdf4', flexShrink: 0 }}>
            <span style={{ fontSize: '12px', fontWeight: '700', color: '#62b875' }}>Sending File ({uploadProgress}%)...</span>
          </div>
        )}

        {/* ব্রডকাস্ট লিস্ট সমূহ (মাঝখানের স্ক্রল এরিয়া) */}
        <div className="scrollable-content">
          {finalBroadcastList.map(list => {
            const isSelected = selectedBroadcastIds.includes(list.id);
            const isPinned = pinnedBroadcastIds.includes(list.id);
            const isActionSelected = selectedBroadcastForAction?.id === list.id;

            return (
              <div 
                key={list.id} 
                className={`broadcast-card-item ${isSelected || isActionSelected ? 'selected-card' : ''}`}
                onTouchStart={() => handleTouchStartCard(list)}
                onTouchEnd={handleTouchEndCard}
                onMouseDown={() => handleTouchStartCard(list)}
                onMouseUp={handleTouchEndCard}
                onContextMenu={(e) => { e.preventDefault(); setSelectedBroadcastForAction(list); }}
                onClick={() => toggleSelectBroadcastList(list)}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flex: 1, overflow: 'hidden' }}>
                  <input type="checkbox" checked={isSelected} readOnly style={{ width: '18px', height: '18px' }} />
                  <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: '#62b875', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
                    📢
                  </div>
                  <div style={{ flex: 1, overflow: 'hidden' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '800', color: '#0f172a' }}>{list.name}</h4>
                      {isPinned && <span style={{ fontSize: '11px' }}>📌</span>}
                    </div>
                    <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#64748b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {list.memberUids?.length || 0} recipients • {list.lastMessage || 'No messages sent'}
                    </p>
                  </div>
                </div>

                {/* View History Button */}
                <button 
                  onClick={(e) => { e.stopPropagation(); setViewingHistoryList(list); }}
                  style={{ padding: '6px 14px', background: '#e2f4e6', color: '#15803d', border: 'none', borderRadius: '12px', fontSize: '12px', fontWeight: '800', cursor: 'pointer', flexShrink: 0 }}
                >
                  View
                </button>
              </div>
            );
          })}
        </div>

        {/* ফিক্সড ইনপুট টাইপিং ফুটার বার */}
        <form onSubmit={handleSendText} className="chat-input-form">
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', background: '#f0f2f5', borderRadius: '24px', padding: '0 12px' }}>
            <span style={{ cursor: 'pointer', fontSize: '18px', marginRight: '6px' }}>😊</span>

            <input
              type="text"
              placeholder={selectedBroadcastIds.length > 0 ? `Message to ${selectedBroadcastIds.length} lists...` : "Select broadcast list(s) above..."}
              value={messageText}
              disabled={selectedBroadcastIds.length === 0}
              onChange={e => setMessageText(e.target.value)}
              style={{ flex: 1, padding: '10px 0', background: 'none', border: 'none', color: '#0f172a', outline: 'none', fontSize: '14px' }}
            />

            <button type="button" onClick={() => fileInputRef.current?.click()} disabled={selectedBroadcastIds.length === 0} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 4px' }} title="Attach Document">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
            </button>

            <button type="button" onClick={() => mediaInputRef.current?.click()} disabled={selectedBroadcastIds.length === 0} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 4px' }} title="Attach Photo/Video">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
            </button>
          </div>

          {/* সেন্ড / ভয়েস একশন বাটন */}
          {messageText.trim() ? (
            <button type="submit" disabled={selectedBroadcastIds.length === 0} className="black-action-btn" title="Send Broadcast">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.5"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
            </button>
          ) : (
            <button type="button" onClick={openVoiceModal} disabled={selectedBroadcastIds.length === 0} className="black-action-btn" title="Voice Card Modal">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" style={{ transform: 'translateY(1px)' }}><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
            </button>
          )}

        </form>

      </div>
    </div>
  );
};

const styles = {
  container: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#fafafa', display: 'flex', justifyContent: 'center', alignItems: 'center' }
};

export default BroadcastScreen;